import React from "react";
import "./heroSection.css";
import "../../index.css";
import Button from "../button/button";
import { useState } from "react";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";
import PopUpFormDownloadScorecard from "../../popUpForms/popUpFormDownloadScorecard";
import PopUpScorecardFormFeedback from "../../popUpForms/popUpScorecardFormFeedback";

const HeroScorecardSection = (s) => {
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [uploadFormVisible, setUploadFormVisible] = useState(false);

  const handleShowPopUpForm = () => {
    setPopUpFormVisible(true);
  };

  // For now the Upload Scorecard button opens the Feedback/Upload form.
  // A dedicated upload form will be designed later.
  const handleShowUploadForm = () => {
    setUploadFormVisible(true);
  };

  return (
    <>
      <div className="scorecard banner-container">
        <div className="bg-image">
          <img
            src="/images/scorecard/scorecard-home-2.webp"
            alt="Scorecard Home"
          />
          <div className="overlay"></div>
        </div>
        <div className="large-screen-limit">
          <div className="hero-content-wrapper">
            <div className="banner-text-right">
              Aldercroft Heights Community Inspection
            </div>
            <div className="scorecard banner-text-left large-screen-limit">
              <div className="overlay">
                <div className="hero-title-row">
                  <h2 className="banner-top hero-text">
                    Catastrophic Fires Destroy
                  </h2>
                  <img
                    className="revised-badge hero-revised-badge"
                    src="/images/scorecard/revised-badge.svg"
                    alt="Revised"
                  />
                </div>
                <h1 className="hero-text banner-mid">
                  Community Preparation Saves{" "}
                </h1>
                <h4 className="banner-bottom hero-text">
                  Everyone's contribution counts. Together we overcome
                  catastrophe.
                </h4>
                <div className="hero-btn-group">
                  <Button
                    text="Download Scorecard"
                    color="var(--cornflower-blue)"
                    onClick={handleShowPopUpForm}
                  />
                  <Button
                    text="Upload Scorecard"
                    color="var(--green)"
                    onClick={handleShowUploadForm}
                  />
                </div>
              </div>
            </div>
            <div className="scorecard banner-photo-credit-container">
              <p className="banner-credit">Photo credit: C. Brenner</p>
            </div>
          </div>
        </div>
      </div>
      <PopUpModal
        activeForm={"download"}
        formActiveState={popUpFormVisible}
        setFormActiveState={setPopUpFormVisible}
      >
        <PopUpFormDownloadScorecard />
      </PopUpModal>
      <PopUpModal
        activeForm={"scorecard-feedback"}
        formActiveState={uploadFormVisible}
        setFormActiveState={setUploadFormVisible}
      >
        <PopUpScorecardFormFeedback />
      </PopUpModal>
    </>
  );
};

export default HeroScorecardSection;
